<template>
  <div>

    <div class="no-title" v-if="anaInfosShow">
      <div v-for="(item, index) in anaInfosTemp" :key="index">
        <div v-if="item.type == 1" style="margin-bottom: 8px;">
          <div v-if="item.data.style == 'H1'" style="font-size: 19px;font-weight:700;text-align: center;">{{
            item.data.strings }}</div>
          <div v-else-if="item.data.style == 'H2'" style="font-size: 18px;font-weight:700;">{{ item.data.strings }}</div>
          <div v-else-if="item.data.style == 'H3'" style="font-size: 17px;font-weight:700;">{{ item.data.strings }}</div>
          <div v-else style="font-size: 16px;">{{ item.data.strings }}</div>
        </div>
        <div v-if="item.type == 2">
          <div style="font-size: 13px;color: #666;text-align: center;">{{ item.data.name }}</div>
          <table cellspacing="0">
            <thead>
              <tr>
                <th v-for="(head, index2) in item.data.head" :key="index2">{{ head }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(body, index2) in item.data.body" :key="index2">
                <td v-for="(bodyItem, index3) in body" :key="index3">{{ bodyItem }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="item.type == 3" class="anaInfos" style="margin-bottom: 8px;">
          <div :id="'echarts-anaInfos-' + index" style="width: 100%;height: 300px;"></div>
        </div>
        <div v-if="item.type == 20">

          <div v-for="(item2, index2) in item.data.chartAnalysis" :key="index2">

            <div style="margin-bottom: 10px;">
              <div
                style="background-color: #e0e0e0;color: #000;padding: 7px 10px;border-radius: 5px;display: inline-block;margin-right: 10px;">
                {{ item.data.chartNames[index2] }}
              </div>
            </div>

            <div v-for="(item3, index3) in item2" :key="index3">
              <div v-if="item3.type == 2">
                <div style="margin-bottom: 10px;">
                  <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;">
                    <table cellspacing="0" style="width: auto;min-width: 100%;">
                      <thead>
                        <tr>
                          <th v-for="(head, index4) in item3.data.head" :key="index4">{{ head }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(body, index4) in item3.data.body" :key="index4">
                          <td v-for="(bodyItem, index5) in body" :key="index5">{{ bodyItem }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div v-if="profitShow">
      <div v-if="profitData.head != null && profitData.head.length > 0">
        <table cellspacing="0">
          <thead>
            <tr>
              <th v-for="(head, index) in profitData.head" :key="index">{{ head }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(body, index) in profitData.body" :key="index">
              <td>{{ body.subjectName == null ? '-' : body.subjectName }}</td>
              <td>{{ (body.currentValue == null || body.currentValue == '未出') ? '-' : body.currentValue }}</td>
              <td>{{ (body.evaluate == null || body.evaluate == '未出') ? '-' : body.evaluate }}</td>
              <td>{{ body.score == null ? '-' : body.score }}</td>
              <td v-if="body.details == null">-</td>
              <td v-if="body.details != null" @click="viewAnaInfos(body.details)" style="color: #0770c4;cursor:pointer;">
                查看
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="singleShow">
      <div id="echarts-single" style="width: 100%;height: 300px;"></div>
      <div v-if="singleData.tableInfo != null && singleData.tableInfo.length > 0">
        <table cellspacing="0">

          <template v-for="(tableRow, index) in singleData.tableInfo">
            <tr v-if="index < singleData.tableInfo[0][0].rowNum" :key="'th' + index">
              <th v-for="(item2, index2) in tableRow" :key="'th-' + index2" :colspan="item2.colNum"
                :rowspan="item2.rowNum">
                {{ item2.content }}</th>
            </tr>
            <tr v-else :key="'td' + index">
              <td v-for="(item2, index2) in tableRow" :key="'td-' + index2">{{ item2.content }}</td>
            </tr>
          </template>

        </table>
      </div>
    </div>

    <el-dialog title="" :visible.sync="anaInfos2Show" :modal="false" :append-to-body="true" width="59%">
      <anaInfos2 v-if="anaInfos2Show" :anaType="anaType2" :anaData="anaData2"></anaInfos2>
    </el-dialog>

  </div>
</template>
      
<script>
import * as echarts from "echarts";
import { linkName } from '../../../../static/js/util';
import anaInfos2 from './anaInfos-second.vue';

export default {
  props: [
    'anaType',
    'anaData'
  ],
  components: {
    anaInfos2
  },
  data() {
    return {
      anaInfosShow: false,
      anaInfosTemp: [],

      profitShow: false,
      profitData: {},

      singleShow: false,
      singleData: {
        tableInfo: [],
        echartsInfo: {}
      },

      anaInfos2Show: false,
      anaType2: 0,
      anaData2: null,
    };
  },
  mounted() {
    // console.log(this.anaType)
    // console.log(this.anaData)
    if (this.anaType == 1) {
      this.anaInfosShow = true;
      this.anaInfosTemp = this.anaData;

      //清除echarts图
      // $('.anaInfos div[_echarts_instance_]').html("");
      // $('.anaInfos div[_echarts_instance_]').removeAttr("_echarts_instance_");

      for (var i = 0; i < this.anaInfosTemp.length; i++) {
        if (this.anaInfosTemp[i].type == 3) {
          this.drawECharts('echarts-anaInfos-' + i, this.anaInfosTemp[i].data);
        }
      }
    } else if (this.anaType == 2) {
      this.profitShow = true;
      this.profitData = this.anaData
    } else if (this.anaType == 3) {
      this.singleShow = true;
      this.singleData = this.anaData;

      this.drawECharts('echarts-single', JSON.stringify(this.singleData.echartsInfo));
    }
  },
  methods: {
    //画echarts图
    drawECharts(idName, data) {
      setTimeout(() => {
        // console.log(idName)
        var chartDom = document.getElementById(idName);
        var myChart = echarts.init(chartDom);
        var option = JSON.parse(data);
        option && myChart.setOption(option);
      }, 300)
    },
    viewAnaInfos(data) {
      this.anaType2 = 1;
      this.anaData2 = data;
      this.anaInfos2Show = true;
    },
  }
};
</script>
      
<style scoped>
table {
  width: 100%;
  text-align: center;
  border: 1px solid #999;
  border-top: 0px;
  border-right: 0px;
}

th,
td {
  line-height: 30px;
}

th {
  background-color: #e6e6e6;
}

th,
td {
  border-top: 1px solid #999;
  border-right: 1px solid #999;
}


.no-title .el-dialog__headerbtn {
  top: 7px;
  right: 10px;
}


</style>